
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CoinTypeService } from '../../services/CoinTypeService';
import * as CoinTypeActions from './coin-type.actions';
import { catchError, map, mergeMap, of, tap } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class CoinTypeEffects {
  loadCoinTypes$;
  addCoinType$;
  updateCoinType$;

  constructor(
    private actions$: Actions,
    private coinTypeService: CoinTypeService,
    private snackBar: MatSnackBar
  ) {
    this.loadCoinTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(CoinTypeActions.loadCoinTypes),
        mergeMap(() =>
          this.coinTypeService.getCoinTypes().pipe(
            map((coinTypes) => CoinTypeActions.loadCoinTypesSuccess({ coinTypes }))
          )
        )
      )
    );

    this.addCoinType$ = createEffect(() =>
      this.actions$.pipe(
        ofType(CoinTypeActions.addCoinType),
        mergeMap((action) =>
          this.coinTypeService.addCoinType(action.coinType).pipe(
            map((coinType) => CoinTypeActions.addCoinTypeSuccess({ coinType })),
            tap(() => this.snackBar.open('CoinType erfolgreich hinzugefügt.', 'Schließen', { duration: 2500 })),
            catchError((error) => {
              this.snackBar.open('Fehler beim Hinzufügen des CoinTypes.', 'Schließen', { duration: 2500 });
              return of(CoinTypeActions.addCoinTypeFailure({ error }));
            })
          )
        )
      )
    );

    this.updateCoinType$ = createEffect(() =>
      this.actions$.pipe(
        ofType(CoinTypeActions.updateCoinType),
        mergeMap((action) =>
          this.coinTypeService.updateCoinType(action.coinType).pipe(
            map((coinType) => CoinTypeActions.updateCoinTypeSuccess({ coinType })),
            tap(() => this.snackBar.open('CoinType erfolgreich aktualisiert.', 'Schließen', { duration: 2500 })),
            catchError((error) => {
              this.snackBar.open('Fehler beim Aktualisieren des CoinTypes.', 'Schließen', { duration: 2500 });
              return of(CoinTypeActions.updateCoinTypeFailure({ error }));
            })
          )
        )
      )
    );
  }
}
